import { useEffect } from "react";
import LegalLayout from "@/components/LegalLayout";

const TermsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <LegalLayout title="Terms and Conditions" lastUpdated="February 2026">
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          1. Acceptance of Terms
        </h2>
        <p className="text-[#5A5A5A] mb-4">
          By accessing and using LoBe ("the Service"), you accept and agree to be bound by these Terms and 
          Conditions. If you do not agree to these terms, please do not use our Service.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          2. Description of Service
        </h2>
        <p className="text-[#5A5A5A] mb-4">
          LoBe provides a platform for creating novelty certificates for <strong>entertainment purposes only</strong>. These certificates are:
        </p>
        <ul className="list-disc list-inside text-[#5A5A5A] space-y-2 mb-4">
          <li>NOT legal documents of any kind</li>
          <li>NOT proof of marriage, partnership, or any relationship</li>
          <li>Purely for entertainment and novelty purposes</li>
          <li>Created for fun and amusement only</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          3. User Responsibilities
        </h2>
        <p className="text-[#5A5A5A] mb-4">
          When using our Service, you agree to:
        </p>
        <ul className="list-disc list-inside text-[#5A5A5A] space-y-2">
          <li>Provide accurate information</li>
          <li>Not use the Service for any illegal purposes</li>
          <li>Not create certificates with offensive, defamatory, or inappropriate content</li>
          <li>Not impersonate other individuals without their consent</li>
          <li>Not use the Service to harass, abuse, or harm others</li>
          <li>Understand certificates are for entertainment only</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          4. Payment Terms
        </h2>
        <p className="text-[#5A5A5A] mb-4">
          Our pricing model is as follows:
        </p>
        <ul className="list-disc list-inside text-[#5A5A5A] space-y-2 mb-4">
          <li>One-time payment only - no subscriptions</li>
          <li>Payments are non-refundable once the certificate is generated</li>
          <li>Pricing: ₹49 for India, $0.89 for other countries</li>
          <li>All payments are processed securely through Razorpay</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          5. Certificate Content
        </h2>
        <p className="text-[#5A5A5A] mb-4">
          Once a certificate is created and payment is completed:
        </p>
        <ul className="list-disc list-inside text-[#5A5A5A] space-y-2">
          <li>The content becomes permanent and cannot be modified</li>
          <li>You are solely responsible for the content you submit</li>
          <li>We reserve the right to remove certificates that violate these terms</li>
          <li>We do not guarantee perpetual availability of the Service</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          6. Intellectual Property
        </h2>
        <p className="text-[#5A5A5A] mb-4">
          The LoBe brand, logo, and certificate designs are owned by LoBe. You retain ownership of the 
          content you provide for your certificate, but grant us a license to display and process it 
          for the purpose of providing the Service.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          7. Limitation of Liability
        </h2>
        <p className="text-[#5A5A5A] mb-4">
          LoBe is provided "as is" without any warranties. We are not liable for any damages arising 
          from the use of our Service, including but not limited to direct, indirect, incidental, 
          or consequential damages.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          8. Changes to Terms
        </h2>
        <p className="text-[#5A5A5A] mb-4">
          We reserve the right to modify these terms at any time. Continued use of the Service after 
          changes constitutes acceptance of the new terms.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          9. Contact
        </h2>
        <p className="text-[#5A5A5A]">
          For questions about these Terms, please contact us at{" "}
          <a href="mailto:support@lobe.love" className="text-[#E8A0BF] hover:underline">
            support@lobe.love
          </a>
        </p>
      </section>
    </LegalLayout>
  );
};

export default TermsPage;
